import { render, staticRenderFns } from "./bottomMargin-editor.vue?vue&type=template&id=e01cfebe&scoped=true"
import script from "./bottomMargin-editor.vue?vue&type=script&lang=js"
export * from "./bottomMargin-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01cfebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e01cfebe')) {
      api.createRecord('e01cfebe', component.options)
    } else {
      api.reload('e01cfebe', component.options)
    }
    module.hot.accept("./bottomMargin-editor.vue?vue&type=template&id=e01cfebe&scoped=true", function () {
      api.rerender('e01cfebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid/bottomMargin-editor.vue"
export default component.exports